import React from 'react'
import { Switch } from '@chakra-ui/react'
import { FaGamepad } from 'react-icons/fa6'

import MenuItem from '~components/shared/menu/menu-item'
import { useDemoMode } from '~utils/hooks/use-demo-mode'

/**
 * SuperAdmin demo-mode toggle. Lives in the account menu rather than the
 * header so the header stays reserved for everyday clinic actions.
 */
export default function DemoModeMenuItem({
    isSuperAdmin,
}: {
    isSuperAdmin: boolean
}) {
    const { isDemoMode, toggleDemoMode } = useDemoMode()

    if (!isSuperAdmin) return null

    return (
        <MenuItem
            icon={FaGamepad}
            onClick={toggleDemoMode}
            justifyContent="space-between"
            closeOnSelect={false}
            color={isDemoMode ? 'orange.600' : undefined}
        >
            Demo Mode
            <Switch
                isChecked={isDemoMode}
                size="sm"
                colorScheme="orange"
                pointerEvents="none"
                ml={3}
            />
        </MenuItem>
    )
}
